module.exports = __webpack_public_path__ + "img/pr-5.cf094a96.png";